import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../assets/css/missionvisionvalues.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRocket, faTrophy, faLeaf,faChartLine, faUsers ,faHandshake} from '@fortawesome/free-solid-svg-icons';



const MissionVisionValues = () => {
  const visions = [
    { icon: faRocket , title: 'Innovation', description: 'Delivering innovative and energy-efficient cooling solutions for residential and commercial spaces.', color: '#3c348d' },
    { icon: faTrophy, title: 'Excellence', description: 'Setting industry benchmarks in customer satisfaction and service excellence.', color: '#3c348d' },
    { icon: faChartLine, title: 'Expansion', description: 'Expanding our service reach while maintaining high standards in quality and professionalism.', color: '#3c348d' },
    { icon: faHandshake, title: 'Partnerships', description: 'Building long-term partnerships with top brands and manufacturers to offer the best products.', color: '#3c348d' },
    { icon: faLeaf, title: 'Sustainability', description: 'Promoting sustainable and eco-friendly air conditioning solutions for a better future.', color: '#3c348d' },
    { icon: faUsers, title: 'Community', description: 'Creating positive impact in communities through responsible business practices.', color: '#3c348d' },
  ];

  const values = [
    { title: 'Integrity', description: 'We conduct our business with the highest standards of professional behavior and ethics.' },
    { title: 'Innovation', description: 'We continuously seek new ways to improve and provide better solutions.' },
    { title: 'Excellence', description: 'We strive for excellence in every aspect of our service delivery.' },
    { title: 'Sustainability', description: 'We are committed to environmental responsibility and sustainable practices.' },
  ];

  return (
    <>
      {/* Mission Section */}
      <section className="mission-section py-5">
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="section-title fw-bold">Our Mission</h2>
          </div>
          
          <div className="row g-4 align-items-center">
            <div className="col-lg-6">
              <div className="mission-list">
                {[
                  "High-Quality and Competitive Air Conditioning Solutions tailored to customer needs.",
                  "Efficient Pre- and Post-Sales Support to ensure long-term satisfaction.",
                  "Well-Trained and Committed Professionals delivering excellent service.",
                  "Continuous Business Process Improvement for greater efficiency.",
                  "Strong Customer Relationships built on trust and reliability.",
                ].map((item, index) => (
                  <div key={index} className="mission-item">
                    <div className="mission-icon">
                      <i className="bi bi-check-circle-fill"></i>
                    </div>
                    <div className="mission-content">
                      <p>{item}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            
            <div className="col-lg-6">
              <div className="mission-image-container" >
                <div className="mission-image-wrapper">
                  <img class="object-cover rounded shadow-sm img-fluid" alt="Mission" src="https://public.readdy.ai/ai/img_res/17cb5afa27646dde8d27dd71c9f35fad.jpg"/>
                </div>
                <div className="mission-image-accent"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Vision Section */}
      <section className="vision-section py-5">
        <div className="container">
          <div className="text-center mb-5" data-aos="fade-right" data-aos-delay="300">
            <h2 className="section-title fw-bold">Our Vision</h2>
          </div>
          
          <div className="row g-4">
            {visions.map((vision, index) => (
              <div key={index} className="col-md-4 mb-4">
                <div className="vision-card">
                  <div className="vision-wrapper">
                    <FontAwesomeIcon icon={vision.icon} className="vision-icon" style={{ color: vision.color }} />
                    <div className="icons-background"></div>
                  </div>
                  <h5 className="vision-title">{vision.title}</h5>
                  <p className="vision-description">{vision.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Core Values Section */}
      <section className="values-section py-5">
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="section-title fw-bold text-white">Our Core Values</h2>
          </div>
          
          <div className="row g-4 justify-content-center">
            {values.map((value, index) => (
              <div key={index} className="col-md-6 col-lg-3">
                <div className="value-card">
                  <div className="value-icon">
                    <i className={`bi bi-${['shield-check', 'lightbulb', 'trophy', 'leaf'][index]}`}></i>
                  </div>
                  <h5 className="value-title">{value.title}</h5>
                  <p className="value-description">{value.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default MissionVisionValues;
